import React from 'react';
import './accesorios.css';

const Accesorios = () => {
  const data = [
  { img: './images_accesorios/ToolKit.webp', name: 'Tool Kit, Sigma Series Chamber', description: 'Caja de herramientas con lo imprescindible para el mantenimiento que debe realizar el usuario.' },
  { img: './images_accesorios/Seal.webp', name: 'Seal, Main Hatch, Sigma 36', description: 'Repuesto Junta de goma de la puerta.' },
  { img: './images_accesorios/Cover.webp', name: 'Chamber Acrylic Cover, Sigma 36', description: 'Cobertor a medida para usar al finalizar el día y durante periodos de no uso. Previene de suciedad y de posibles rayajos.' },
  { img: './images_accesorios/Pillow.webp', name: 'Almohada de algodón y funda', description: 'Se recomienda contar con un par de almohadas con su funda por cada cámara.' },
  { img: './images_accesorios/TVSupport.webp', name: 'Soporte del Sistema de entretenimiento (TV)', description: 'Soporte para el montaje de TV (TV de origen local) y el cable de entrada de 6 m de sonido auxiliar incluido.' },
  { img: './images_accesorios/AuxCable.webp', name: 'Cable auxiliar solo para sonido interior de 6m', description: '' },
  { img: './images_accesorios/CleaningEquipment.webp', name: 'Equipo de limpieza Eco Cleaning & desinfection system', description: '' },
  { img: './images_accesorios/WedgeCushion.webp', name: 'Cojín de Cuña con funda protectora adaptada', description: '' },
  { img: './images_accesorios/MonitorCable.webp', name: 'Cable y conector para monitor transcutáneo', description: '(Compatible con Radiometer o Perimed).' },
  { img: './images_accesorios/Wristband.webp', name: 'Pulsera de muñeca antiestática,  con 3,65 m de cable', description: 'Por higiene, se recomienda que cada paciente cuente con su brazalete hasta terminar el tratamiento.' },
  { img: './images_accesorios/WristbandChecker.webp', name: 'Comprobador portátil de pulsera', description: 'De muy fácil uso, garantiza la efectividad de la pulsera antiestática. Muy práctico y de uso frecuente.' },
  { img: './images_accesorios/InfusionConnector.webp', name: 'Penetrador y conectores para la conexión de bomba de infusión (no Incluida) / Ventilator Bracket Assembly', description: '' },
  { img: './images_accesorios/AdultMask.webp', name: 'Máscara para paciente - Adulto', description: 'Por higiene, se recomienda que cada paciente cuente con su máscara hasta terminar el tratamiento' },
  { img: './images_accesorios/Sheets.webp', name: 'Sábanas y almohadones con indicativo "Hyperbaric use only", 100% algodón', description: '' },
  { img: './images_accesorios/Clothes.webp', name: 'Ropa para paciente, tallas variadas. Camisones "Hyperbaric use only", 100% algodón', description: '' }
];


  return (
    <div className="accesorios-container">
      <table className="accesorios-table">
        <tbody>
          {data.map((item, index) => (
            <tr key={index} className="accesorios-row">
              <td className="accesorios-image-cell">
                <img className="accesorios-image" src={item.img} alt={item.name} />
              </td>
              <td className="accesorios-text-cell">
                <h3 className="accesorios-name">{item.name}</h3>
                <p className="accesorios-description">{item.description}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Accesorios;
